<template>
  <div class="promo-badge">
    <div class="promo-badge__text" v-html="text"></div>
  </div>
</template>

<script>
import './PromoBadge.scss';

export default {
  name: 'PromoBadge',
  props: {
    text: {
      type: String,
    },
  },
};
</script>
